import { toastr } from "react-redux-toastr";
import {
  CONTEST_API,
  LOT_POP,
  MEGA_API,
  NEW_DESIGN_CONTEST,
  NEW_DESIGN_LOT_POP,
  NEW_DESIGN_SERIAL,
  NEW_DESIGN_SISTEMA_ID,
} from "../../modules/constants";

// Imports
import { doRequest } from "../../modules/request";

export const RECEIVE_RESULTADO = "RECEIVE_RESULTADO";
export const CLEAN_RESULTADO = "CLEAN_RESULTADO";
export const LOADING_RESULTADO = "LOADING_RESULTADO";

export const changeLoadingResultado = (payload) => ({
  type: LOADING_RESULTADO,
  payload,
});

export const receiveResultado = (payload) => ({
  type: RECEIVE_RESULTADO,
  payload: payload,
});

export const cleanResultado = (payload) => ({
  type: CLEAN_RESULTADO,
  payload: payload,
});

export const recuperaResultado =
  (ParamResultado, callback, isNewDesign = false) =>
  (dispatch, getState) => {
    dispatch({ type: LOADING_RESULTADO });

    const url = isNewDesign
      ? CONTEST_API + NEW_DESIGN_LOT_POP
      : MEGA_API + LOT_POP;

    const customParams = isNewDesign
      ? {
          Sistema_ID: NEW_DESIGN_SISTEMA_ID,
          chrSerial: NEW_DESIGN_SERIAL,
        }
      : {
          Sistema_ID: ParamResultado.Sistema_ID,
          chrSerial: ParamResultado.chrSerial,
        };

    const params = {
      url,
      method: "POST",
      data: {
        ...ParamResultado,
        ...customParams,
      },
    };

    return doRequest(params)
      .then((response) => {
        if (response.intCodigoRetorno > 0) {
          toastr.error("Atenção", response.strErrorMessage);
          dispatch(
            receiveResultado({
              resultadoJBWeb: undefined,
            })
          );
        } else {
          dispatch(receiveResultado(response));
        }
        dispatch({ type: LOADING_RESULTADO });
        callback();
      })
      .catch((error) => {
        toastr.error("Houve um erro ao buscar resultado.", error.message);
        dispatch(
          receiveResultado({
            resultadoJBWeb: undefined,
          })
        );
        dispatch({ type: LOADING_RESULTADO });
        callback();
      });
  };

export const recuperaResultadoTipoConcurso =
  (ParamResultado, callback, isNewDesign) => (dispatch, getState) => {
    dispatch({ type: LOADING_RESULTADO });
    const params = {
      url: CONTEST_API + NEW_DESIGN_CONTEST,
      method: "POST",
      data: {
        ...ParamResultado,
        Sistema_ID: NEW_DESIGN_SISTEMA_ID,
        chrSerial: NEW_DESIGN_SERIAL,
        strData: ParamResultado.date,
      },
    };

    return doRequest(params)
      .then((response) => {
        if (response.intCodigoRetorno > 0) {
          toastr.error("Atenção", response.strErrorMessage);
          dispatch(
            receiveResultado({
              resultadoJBWeb: undefined,
            })
          );
        } else {
          dispatch(receiveResultado(response));
        }
        dispatch({ type: LOADING_RESULTADO });
        callback();
      })
      .catch((error) => {
        toastr.error("Houve um erro ao buscar resultado.", error.message);
        dispatch(
          receiveResultado({
            resultadoJBWeb: undefined,
          })
        );
        dispatch({ type: LOADING_RESULTADO });
        callback();
      });
  };



// WEBPACK FOOTER //
// ./src/reducers/relatorios/resultadosActions.js